var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 8,
    fill: "#081439"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 17C7 12.286 7 9.92893 8.46447 8.46447C9.92893 7 12.286 7 17 7C21.714 7 24.0711 7 25.5355 8.46447C27 9.92893 27 12.286 27 17C27 21.714 27 24.0711 25.5355 25.5355C24.0711 27 21.714 27 17 27C12.286 27 9.92893 27 8.46447 25.5355C7 24.0711 7 21.714 7 17Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19L14.2929 16.7071C14.6834 16.3166 15.3166 16.3166 15.7071 16.7071L17.2929 18.2929C17.6834 18.6834 18.3166 18.6834 18.7071 18.2929L22 15M22 15V17.5M22 15H19.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter2);
export default __webpack_public_path__ + "static/media/filter2.e2c62705e889c4da4e89928a6f472d24.svg";
export { ForwardRef as ReactComponent };